<template>
    <v-flex v-if="object_id" lg2 md3 xs12 mb-0 pb-0>
        <vue-perfect-scrollbar class="scroll-area search_list" :style="$bp.xs ? null : 'max-height: calc(100vh - 180px); min-height: calc(100vh - 180px)'">
            <v-navigation-drawer style="width: auto !important; box-shadow: none !important; border: none !important" permanent>
                <div v-if="items && items.length > 0" class="font-weight-bold ml-8 mb-2">Document Timeline</div>

                <v-timeline v-if="items && items.length > 0" align-top dense>
                    <v-timeline-item v-for="item in items" :color="item.dot_class" v-bind="item.is_self == '1' ? {} : { small: true }">
                        <div style="cursor: pointer" class="underline-on-hover">
                            <div class="font-weight-normal" @click="$router.push({ name: item.link_object_ref, params: { id: item.link_object_id } })">
                                <strong>{{ $t(`lang.${item.link_object_ref}_link_object`) }} {{ `#${item.link_object_id}` }}</strong>
                            </div>
                            <div class="font-weight-normal">{{ item.company }}</div>
                            <small>{{ item.transaction_date }}</small>
                            <!-- <small :style="{ color: item.status_class }">{{ item.status }}</small> -->
                            <v-chip label outline class="ml-4" :color="item.status_class">
                                <span :style="{ color: item.status_class }" class="caption text-uppercase fs-10">{{ item.status }}</span>
                            </v-chip>
                        </div>
                    </v-timeline-item>
                </v-timeline>
                <div v-else class="font-weight-bold ml-8 mb-2">No Linked Documents</div>
            </v-navigation-drawer>
        </vue-perfect-scrollbar>
    </v-flex>
</template>

<script>
import { store } from "Store/store";

export default {
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        object_id: {
            type: [String, Number],
            default: null,
        },
    },
    data() {
        return {};
    },
};
</script>
<style lang="css" scoped>
.underline-on-hover strong {
    position: relative;
    display: inline-block;
}

.underline-on-hover strong::after {
    content: " ";
    background-color: black;
    width: 0;
    position: absolute;
    left: 0;
    bottom: 2px;
    height: 2px;

    -webkit-transition: width 0.5s ease-in-out;
    -moz-transition: width 0.5s ease-in-out;
    -o-transition: width 0.5s ease-in-out;
    transition: width 0.5s ease-in-out;
}

.underline-on-hover:hover strong::after {
    width: 100%;
}

.v-chip {
    height: 20px !important;
}

.fs-10 {
    font-size: 10px !important;
}
</style>
